import { render, staticRenderFns } from "./customFilterBL.vue?vue&type=template&id=63bf70ac&scoped=true&"
import script from "./customFilterBL.vue?vue&type=script&lang=js&"
export * from "./customFilterBL.vue?vue&type=script&lang=js&"
import style0 from "./customFilterBL.vue?vue&type=style&index=0&id=63bf70ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bf70ac",
  null
  
)

export default component.exports